import T from "../../translations/Translations";

import "../../../styles/Modals.scss";

const InvalidDobModalForm = () => {
    return T({ key: "OE_Modal_Ineligible" });
};

export default InvalidDobModalForm;
